module.exports = __webpack_public_path__ + "static/media/md-close-circle-outline.629b03c8.svg";